import tools from './tools.js';

export default {


	blockSchedule(arrInfo, curTimeZone){
//<h4 class="mt-5">Программы и показы:</h4>
		let buildHTML = `<div class="row m-0 p-0">`;

      	for (let i = 0; i < arrInfo.length; i++) 
        	buildHTML += `<div class="column scheduleLabel">
                            <b  class="txt-al-center w-100">${tools.dateStringFullAddTimeZone(arrInfo[i].timeStart, curTimeZone)}${arrInfo[i].timeEnd ? ` - ${tools.dateStringOnlyHoursWithMinAddTimeZone(arrInfo[i].timeEnd, curTimeZone)}` :''}</b>
                            <small class="txt-al-center w-100">${arrInfo[i].placeName}${arrInfo[i].hallName? (` -  ${arrInfo[i].hallName}` ) : '' }</small>
                          </div>`;

      	buildHTML += '</div>';

      	return buildHTML;
	},


	blockScheduleWithNameProgram(arrInfo, curTimeZone){
		//<h4 class="mt-5">Программы и показы:</h4>
		let buildHTML = `<div class="row m-0 p-0">`;

      	for (let i = 0; i < arrInfo.length; i++) 
        	buildHTML += `<div class="column scheduleLabel">
                            <b  class="txt-al-center w-100">${tools.dateStringFullAddTimeZone(arrInfo[i].timeStart, curTimeZone)}${arrInfo[i].timeEnd ? ` - ${tools.dateStringOnlyHoursWithMinAddTimeZone(arrInfo[i].timeEnd, curTimeZone)}` :''}</b>
                            <small class="txt-al-center w-100">${arrInfo[i].name}</small>
                            <small class="txt-al-center w-100">${arrInfo[i].placeName}${arrInfo[i].hallName? (` -  ${arrInfo[i].hallName}` ) : '' }</small>
                          </div>`;

      	buildHTML += '</div>';
      	return buildHTML;
	},

	blockArrInProgram(arrInfo, curTimeZone){
		//<h4 class="mt-5">Программы и показы:</h4>
		let buildHTML = `<div class="row m-0 p-0">`;

      	for (let i = 0; i < arrInfo.length; i++) 
        	buildHTML += `<div class="column scheduleLabel">
                           <small class="txt-al-center w-100">${arrInfo[i].name}</small>
                          </div>`;
      	buildHTML += '</div>';

      	return buildHTML;
	},


};